import { ButtonBase } from '@mui/material';
import './ListText.scss';

interface ListTextProps {
  title: string;
  description: string;
  price: string | React.ReactElement;
  onClick: () => void;
}

const ListText = ({ title, description, price, onClick }: ListTextProps) => {
  return (
    <ButtonBase
      onClick={onClick}
      className="dish dish--list-text"
      component="div"
    >
      <div className="dish__body">
        <div className="dish__body-header">
          <h3 className="dish__title">{title}</h3>
          <p className="dish__description">{description}</p>
        </div>
        <p className="dish__price">{price}</p>
      </div>
    </ButtonBase>
  );
};

export default ListText;
